import { ref, reactive, computed, onMounted } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-457553ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-panel"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "appListPopover-content"
};
const _hoisted_4 = {
  class: "appListPopover-content-title"
};
const _hoisted_5 = {
  class: "inf-label"
};
const _hoisted_6 = {
  class: "inf-value"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_8 = {
  class: "btn-content"
};
import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { OK, detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { queryGoodsOption } from '@/api/goodsSetting';
import { addCollectFetch, removeCollectFetch } from '@/api/payManage/appManage';
import { createDefaultFilters, evidenceStatusOptions } from '../data';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPanel',
  props: {
    loading: {
      type: Boolean
    }
  },
  emits: ["search"],
  setup(__props, {
    emit
  }) {
    const datePickerRef = ref(null);
    const productSelectRef = ref(null);
    const formState = reactive(createDefaultFilters());
    const timeRange = ref([]);
    const appList = ref([]);
    // product-select 绑定：空串转 undefined，使未选中时正常显示 placeholder；
    // 对外 formState.dbtId 仍维持空串语义，传后端参数不变
    const dbtIdModel = computed({
      get: () => formState.dbtId || undefined,
      set: val => {
        formState.dbtId = val !== null && val !== void 0 ? val : '';
      }
    });
    // 获取产品列表并注入下拉
    const getAppData = async () => {
      try {
        const {
          code,
          data
        } = await queryGoodsOption();
        if (code === OK) {
          var _productSelectRef$val;
          appList.value = data.map(item => {
            var _item$extData;
            return {
              ...item,
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
            };
          });
          (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appList.value);
        }
      } catch (e) {
        console.error('获取产品列表失败:', e);
      }
    };
    // 收藏 / 取消收藏
    const handleFavorite = async (type, option) => {
      try {
        const fetchMethod = option.hasFavorite ? removeCollectFetch : addCollectFetch;
        const {
          code
        } = await fetchMethod({
          dbtId: option.dbtId
        });
        if (code === OK) {
          message.success(`${option.hasFavorite ? '取消收藏' : '收藏'}成功`);
          option.hasFavorite = !option.hasFavorite;
        } else {
          throw new Error(`${option.hasFavorite ? '取消收藏' : '收藏'}失败`);
        }
      } catch (error) {
        console.error('收藏操作失败:', error);
        message.error('操作失败，请稍后重试');
      }
    };
    onMounted(() => {
      getAppData();
    });
    const getPopupContainer = triggerNode => triggerNode.parentNode;
    const changeStartHms = value => {
      var _timeRange$value;
      if (!((_timeRange$value = timeRange.value) !== null && _timeRange$value !== void 0 && _timeRange$value[0])) return;
      timeRange.value[0] = `${dayjs(timeRange.value[0]).format('YYYYMMDD')} ${value}`;
    };
    const changeEndHms = value => {
      var _timeRange$value2;
      if (!((_timeRange$value2 = timeRange.value) !== null && _timeRange$value2 !== void 0 && _timeRange$value2[1])) return;
      timeRange.value[1] = `${dayjs(timeRange.value[1]).format('YYYYMMDD')} ${value}`;
    };
    const buildPayload = () => {
      var _timeRange$value3, _timeRange$value4;
      const payload = {
        dbtId: formState.dbtId,
        orderNo: formState.orderNo,
        messageId: formState.messageId
      };
      if (formState.status !== undefined) {
        payload.status = formState.status;
      }
      if ((_timeRange$value3 = timeRange.value) !== null && _timeRange$value3 !== void 0 && _timeRange$value3[0] && (_timeRange$value4 = timeRange.value) !== null && _timeRange$value4 !== void 0 && _timeRange$value4[1]) {
        payload.startTime = dayjs(timeRange.value[0]).format('YYYY-MM-DD HH:mm:ss');
        payload.endTime = dayjs(timeRange.value[1]).format('YYYY-MM-DD HH:mm:ss');
      }
      return payload;
    };
    const handleSearch = () => {
      emit('search', buildPayload());
    };
    const handleReset = () => {
      Object.assign(formState, createDefaultFilters());
      timeRange.value = [];
      if (datePickerRef.value) {
        datePickerRef.value.timeStart = dayjs('00:00:00', 'HH:mm:ss');
        datePickerRef.value.timeEnd = dayjs('23:59:59', 'HH:mm:ss');
      }
      handleSearch();
    };
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        layout: "inline",
        class: "search-form",
        onFinish: handleSearch
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_form_item, {
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_search, {
            value: formState.messageId,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => formState.messageId = $event),
            placeholder: "请输入交易ID",
            "allow-clear": "",
            maxlength: 64,
            onSearch: handleSearch,
            onChange: _cache[1] || (_cache[1] = e => formState.messageId = e.target.value.trim())
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
            ref_key: "productSelectRef",
            ref: productSelectRef,
            modelValue: _unref(dbtIdModel),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dbtIdModel) ? dbtIdModel.value = $event : null),
            multiple: false,
            "show-icon": true,
            "show-extra": true,
            "search-fields": _unref(searchFields),
            "max-tag-count": 1,
            "show-detail": true,
            layout: "vertical",
            width: 200,
            "popup-class-name": "vertical-product-select",
            placeholder: "请选择产品",
            descriptionField: "filePath",
            detailFields: _unref(detailFields),
            allowClear: "",
            "show-bottom-border": ""
          }, {
            icon: _withCtx(({
              type,
              option
            }) => [_createVNode(SvgIcon, {
              iconClass: option.hasFavorite ? 'collectIcon' : 'collectGreyIcon',
              onClick: _withModifiers($event => handleFavorite(type, option), ["stop"]),
              class: "title-svg",
              style: {
                "margin": "0"
              }
            }, null, 8, ["iconClass", "onClick"])]),
            detail: _withCtx(({
              detail
            }) => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(SvgIcon, {
              iconClass: "informationIcon",
              class: "informationIcon"
            }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
              return _openBlock(), _createElementBlock("div", {
                key: child.label,
                class: "inf-line"
              }, [_createElementVNode("div", _hoisted_5, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_6, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                placement: "top"
              }, {
                title: _withCtx(() => [_hoisted_7]),
                default: _withCtx(() => [_createVNode(SvgIcon, {
                  iconClass: "copy",
                  class: "dbt-copyIcon",
                  onClick: $event => _unref(copy)(child.value)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)]);
            }), 128))])]),
            _: 1
          }, 8, ["modelValue", "search-fields", "detailFields"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input_search, {
            value: formState.orderNo,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => formState.orderNo = $event),
            placeholder: "请输入订单号",
            "allow-clear": "",
            maxlength: 64,
            onSearch: handleSearch,
            onChange: _cache[4] || (_cache[4] = e => formState.orderNo = e.target.value.trim())
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          class: "filter-item"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: formState.status,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => formState.status = $event),
            class: "status-select",
            options: _unref(evidenceStatusOptions),
            getPopupContainer: getPopupContainer,
            placeholder: "请选择举证状态",
            "allow-clear": ""
          }, null, 8, ["value", "options"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          class: "filter-item filter-item-time"
        }, {
          default: _withCtx(() => [_createVNode(DbtDatePicker, {
            ref_key: "datePickerRef",
            ref: datePickerRef,
            "show-use-server-time": false,
            "show-header": false,
            "show-dynamic": false,
            "show-quick": false,
            "is-required": false,
            isdeletion: true,
            "show-time-range": "",
            placeholder: ['举证时间', '举证时间'],
            startTime: timeRange.value[0],
            "onUpdate:startTime": _cache[6] || (_cache[6] = $event => timeRange.value[0] = $event),
            endTime: timeRange.value[1],
            "onUpdate:endTime": _cache[7] || (_cache[7] = $event => timeRange.value[1] = $event),
            position: "bottomLeft",
            onChangeStartHms: changeStartHms,
            onChangeEndHms: changeEndHms
          }, null, 8, ["startTime", "endTime"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
          onClick: handleReset,
          class: "reset-btn"
        }, {
          default: _withCtx(() => [_createTextVNode("重置")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          onClick: handleSearch,
          loading: __props.loading
        }, {
          default: _withCtx(() => [_createTextVNode("查询")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      })]);
    };
  }
});